module.exports = __webpack_public_path__ + "img/Anguilla.ed756926.svg";